import { render, staticRenderFns } from "./FormWidget.vue?vue&type=template&id=4498e7bc&scoped=true"
import script from "./FormWidget.vue?vue&type=script&lang=js"
export * from "./FormWidget.vue?vue&type=script&lang=js"
import style0 from "./FormWidget.vue?vue&type=style&index=0&id=4498e7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498e7bc",
  null
  
)

export default component.exports